import { toast } from 'sonner'

import type { IAsyncToastOptions } from './Toast.types'

export const asyncToast = async <T>({
    id,
    promise,
    msgs,
    onSuccess,
    onError,
}: IAsyncToastOptions<T>): Promise<void> => {
    const loadingToastId = toast.loading(msgs.loading, { id })

    try {
        const result = await promise

        toast.success(typeof msgs.success === 'function' ? msgs.success(result) : msgs.success, {
            id: loadingToastId,
        })

        onSuccess?.(result)
    } catch (error) {
        const errorMessage = msgs.error
            ? typeof msgs.error === 'function'
                ? msgs.error(error)
                : msgs.error
            : (error as Error).message || 'Something went wrong'

        toast.error(errorMessage, {
            id: loadingToastId,
        })

        onError?.(error)
    }
}
